<template>
  <div>
    <h1>Associar usuários à equipe {{ this.equipeSelecionada.nome || this.equipeSelecionada.name }}</h1>

    <div
      class="container-dados-equipe"
      v-if="!loadingEquipe && (listaDadosAssociados.length || listaDadosDisponiveis.length)"
    >
      <label>Equipe: {{ this.equipeSelecionada.nome || this.equipeSelecionada.name }}</label>
    </div>

    <SGPAlertaComponent v-else />

    <SGPAssociarComponent
      v-if="listaDadosAssociados.length || listaDadosDisponiveis.length"
      tituloAssociados="Usuários"
      tituloDisponiveis="Usuários"
      :dadoAssociado="listaDadosAssociados"
      :dadoDisponivel="listaDadosDisponiveis"
      @sgpSalvarAssociacoesEmit="usuariosParaAssociar"
    />

    <SGPLoadingComponent v-if="loadingEquipe" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EquipeUsuarioAssociacaoPage',

  data() {
    return {
      listaDadosAssociados: [],
      listaDadosDisponiveis: []
    }
  },

  async created() {
    await this.listarUsuarios()
    await this.recuperarEquipeComUsuarios(this.$route.params.equipe)

    this.atualizarListaDeDadosAssociadosENaoAssociados()
  },

  computed: {
    ...mapGetters('appCtrlEquipes', [
      'loadingEquipe',
      'listaDeUsuarios',
      'equipeSelecionadaComUsuarios'
    ]),

    equipeSelecionada() {
      return this.equipeSelecionadaComUsuarios
    },

    usuariosAssociados() {
      if (!this.equipeSelecionadaComUsuarios?.users) return []

      return this.equipeSelecionadaComUsuarios.users.map(usuario => ({
        id: usuario.id,
        descricao: usuario.name,
        selecionado: false
      }))
    },

    usuariosDisponiveis() {
      const associadosIds = this.equipeSelecionadaComUsuarios?.users?.map(u => u.id) || []
      const todosUsuarios = this.listaDeUsuarios?.data || []

      return todosUsuarios
        .filter(usuario => !associadosIds.includes(usuario.id))
        .map(usuario => ({
          id: usuario.id,
          descricao: usuario.name,
          selecionado: false
        }))
    }
  },

  methods: {
    ...mapActions('appCtrlEquipes', [
      'listarUsuarios',
      'recuperarEquipeComUsuarios',
      'associarUsuariosAEquipe'
    ]),

    atualizarListaDeDadosAssociadosENaoAssociados() {
      this.listaDadosAssociados = this.usuariosAssociados
      console.log(this.listaDadosAssociados)
      this.listaDadosDisponiveis = this.usuariosDisponiveis
    },

    usuariosParaAssociar(value) {
      const listaIdsAssociados = value.listaAssociados.map(usuario => usuario.id)

      const payload = {
        usuarios: listaIdsAssociados,
        equipeId: this.$route.params.equipe
      }

      this.associarUsuariosAEquipe(payload)
    }
  }
}
</script>

<style scoped>
.container-dados-equipe {
  margin-bottom: 20px;
}
</style>
